export enum CashbackWinType {
  CasinoWallet,
  Freebet
}

export enum CashbackClaimingFrequency {
  Daily,
  Weekly,
  Monthly
}

export enum RewardsTabs {
  Progress = 'progress',
  Rules = 'rules'
}

export enum LevelConditionType {
  Turnover,
  BetCount,
  TotalWinAmount,
  WinCount,
  TotalMultiplierCount,
  BuyBonusCount
}
